import { aiFeatures } from '../../../../../api/coreData'

const FEATURE_CODE = 'portfolio-research-agent'

export function useResearchAgentEnabled () {
  const { data, isLoading } = aiFeatures.useListAvailableAiFeatures({
    staleTime: 5 * 60 * 1000
  })
  const features = data?.features ?? []
  const enabled = features.some(f => f.featureCode === FEATURE_CODE)
  return { enabled, isLoading }
}
